<template>
  <v-card class="elevation-0" height="400">
    <v-card-text class="card-height">
      <v-row class="card-height" justify="center" align="center">
        <v-col class="card-height" cols="7">
          <div class="d-flex justify-center img-height">
            <img width="240" height="240" :src="require('@/assets/empty_state.png')" />
          </div>
          <div>
            <p class="mb-0 pl-0 card-title text-center">Ops, não conseguimos encontrar nenhuma mensagem.</p>
            <p class="mb-0 pl-0 card-title text-center">Tente novamente mais tarde</p>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TemplateMessageEmpty',
}
</script>

<style lang="scss">
.card-height {
  height: 100%;
}
.img-height {
  height: 300px;
}
</style>
